import { render, staticRenderFns } from "./RingBar.vue?vue&type=template&id=f72c5894&scoped=true"
import script from "./RingBar.vue?vue&type=script&lang=js"
export * from "./RingBar.vue?vue&type=script&lang=js"
import style0 from "./RingBar.vue?vue&type=style&index=0&id=f72c5894&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72c5894",
  null
  
)

export default component.exports